import axios from 'axios'
import { APIRoute } from '../../../config'
import { GetTournamentAction, getTournamentError, getTournamentSuccess } from '../actions'
import { put } from 'redux-saga/effects'
import { TOURNAMENT_SET_SELECTED_ROUND } from '../constants'

function* getTournamentFlow({ tournamentId, screen }: GetTournamentAction) {
  try {
    const res = yield axios.get(APIRoute.GET_TOURNAMENT(tournamentId), {
      params: {
        screen,
      },
    })

    if (res && !res.error) {
      yield put({
        type: TOURNAMENT_SET_SELECTED_ROUND,
        roundIndex: 0,
      })
      yield put(getTournamentSuccess(res.data))
    } else {
      yield put(getTournamentError(res.data.error))
    }
  } catch (error) {
    console.log(`Tournament ${tournamentId} requested - ${error}`)
    yield put(getTournamentError(error))
  }
}

export default getTournamentFlow
